import reducerFunctions from './_utils/reducerFunctions';
const resourceType = 'lists';
const initialState = {
    init: false,
    error: false,
    loading: false,
    data: null
};

export default function (state = initialState, action) {
    switch(action.type) {
        case 'lists.addItem':
        case 'lists.updateItem':
            return {
                ...state, 
                data: {
                    ...state.data,
                    [action.payload.parent_id]:{
                        ...state.data[action.payload.parent_id],
                        items:{
                            ...state.data[action.payload.parent_id].items,
                            ...action.payload.data
                        }
                    }
                }
            }
        case 'lists.removeItem':
            let items = {...state.data[action.payload.parent_id].items};
            delete items[action.payload.id];
            return {
                ...state, 
                data: {
                    ...state.data,
                    [action.payload.parent_id]:{
                        ...state.data[action.payload.parent_id],
                        items
                    }
                }
            }
        default:
            return reducerFunctions(resourceType, initialState, state, action)
    }
}
